module.exports = __webpack_public_path__ + "img/ZWF_Lunch_Friday.d0c64b82.jpg";